import { connect } from "react-redux";
import ValetUserList from "./ValetUserList";
import { bindActionCreators } from "redux";
import { valetIncentiveList,valetUserBulkApprove } from "services/redux/valetIncentive/action";
const mapStateToProps = (state) => ({
    valetincentivelisting: state.ValetIncentive.valetincentivelisting,
    valetIncentiveFilter: state.ValetIncentive.valetIncentiveFilter,
    bulkApprovalData:state.ValetIncentive.bulkApprovalData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        valetIncentiveList,
        valetUserBulkApprove
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ValetUserList);
